import { useState, useEffect } from 'react';
import {
  Alert,
  Box,
  Checkbox,
  Divider,
  Grid,
  Typography,
  TextField,
  Paper,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Link as MuiLink,
  ListItemIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Modal
} from "@mui/material";

import { styled } from '@mui/material/styles';

import { Formik } from 'formik';
import axios from  'axios';
import { blueGrey } from '@mui/material/colors';
import jwtDecode from 'jwt-decode';

import {
  Search,
  Notifications,
  ShoppingCart,
  Email,
  LocalAtm,
  ExitToApp,
  PowerOffRounded
} from "@material-ui/icons";

import SearchIcon from '@mui/icons-material/Search';
import styledComponent from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import mainLogo from '../../assets/logo.png';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import MuiAlert from '@mui/material/Alert';
import { tableCellClasses } from '@mui/material/TableCell';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '80%', md: 400 },
  maxHeight: '68vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll'
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
[`&.${tableCellClasses.head}`]: {
  color: theme.palette.common.black
},
[`&.${tableCellClasses.body}`]: {
  fontSize: 14,
},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
'&:nth-of-type(odd)': {
  backgroundColor: theme.palette.action.hover,
},
// hide last border
'&:last-child td, &:last-child th': {
  border: 0,
},
}));

const Container = styledComponent.div`
  height: 70px;
  background-color: #c9d0d4;
`;

const Wrapper = styledComponent.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CartItem = styledComponent.div`
  position: absolute;
  color: white;
  padding: 1px 4px;
  margin-left: -9px;
  margin-top: -9px;
  border-radius: 30%;
  background-color: red;
  opacity: 0.9;
`;

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
      return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const Navbar = ({
  cartState,
  UpdatedCartState,
  jmlState,
  totalState,
  UpdatedTotalState,
  UpdatedJmlState,
  UpdatedProductState,
  UpdatedPageInfo,
  UpdatedPageSize,
  UpdatedPage,
  Page,
  PageInfo,
  PageSize
}) => {
    const [cart, setCart] = useState([]);
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClickMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
      setAnchorEl(null);
    };
    const handleLogout = () => {
      localStorage.removeItem('token');
      navigate('/');
    }

    const [token, setToken] = useState(
      JSON.parse(localStorage.getItem('token')) !== null ? 
          JSON.parse(localStorage.getItem('token')).token :
          null
    );

    const [openCart, setOpenCart] = useState(false);
    const [produkStoks, setProdukStoks] = useState([]);
    const [saldoData, setSaldoData] = useState(0);
    const [checkedAllItem, setCheckedAllItem] = useState(false);
    const [tobeCheckedOut, setTobeCheckedOut] = useState([]);
    const [checkedIdProduk, setCheckedIdProduk] = useState([]);
    const [checkedQty, setCheckedQty] = useState(0);
    const [checkedTotal, setCheckedTotal] = useState(0);

    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');

    const handleCloseAlert = (event, reason) => {
      if (reason === 'clickaway') {
          return;
      }
      setOpenAlert(false);
    };

    const handleCloseCart = () => {
      setOpenCart(false);
    };

    const getProducts = async () => {
      try {
        const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/readystok/list`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
          },
          params: {
              page: Page.value,
              perPage: PageSize.value
          }
        });
        let number = 0;
        UpdatedProductState(products.data.result.data.map((v) => {
          number+=1;
          return { ...v, no: number };
        }));
        const pageInfoRes = Object.keys(products.data.result)
          .filter((key) => {
              if (key !== 'data') return true;
              return false;
          })
          .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
        UpdatedPageInfo(pageInfoRes);
      } catch (err) {
        console.log(err);
      }
    }

    const handleValToSubmit = async (row, value) => {
      const newRow = {
        idproduk: row.idproduk,
        jmlh: value
      }
      const updateCart = async () => {
        try {
          await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/add`, newRow, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
          });
          const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
          });

          let tmpTobeCheckedOut = tobeCheckedOut;
          let tmpCheckedQty = 0;
          let tmpCheckedTotal = 0;

          let jmlQ = 0;
          let totalH = 0;
          
          setCart(cartData.data.result);
          
          cartData.data.result.forEach((item) => {
            jmlQ += item.jmlh;
            // totalH += item.subtotal;
            if (new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date) {
              if (item.jenis === 'gamis' || item.jenis === 'koko') {
                totalH += 100000;
              } else {
                totalH += 50000;
              }
            } else {
              totalH += item.subtotal;
            }
            for(let i = 0; i < tmpTobeCheckedOut.length; i++) {
              if(tmpTobeCheckedOut[i].idproduk === item.idproduk) {
                tmpTobeCheckedOut[i].jmlh = item.jmlh;
                tmpTobeCheckedOut[i].subtotal = item.subtotal;
              }
            }
          });

          tmpTobeCheckedOut.forEach((item) => {
            if (new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date) {
              if (item.jenis === 'gamis' || item.jenis === 'koko') {
                tmpCheckedTotal += 100000;
              } else {
                tmpCheckedTotal += 50000;
              }
            } else {
              tmpCheckedTotal += item.subtotal;
            }
            tmpCheckedQty += item.jmlh;
            console.log(tmpCheckedTotal, item);
          })
          // check this
          setCheckedQty(tmpCheckedQty);
          setCheckedTotal(tmpCheckedTotal);

          UpdatedJmlState(jmlQ);
          UpdatedTotalState(totalH);

          setCart(cartData.data.result);
          UpdatedCartState(cartData.data.result);

        } catch (err) {
          setAlertStatus('error');
          setAlertMessage(err.response.data.message);
          setOpenAlert(true);
        }
      };

      await updateCart();
      await getProducts();
    };
    const handleDeleteCart = async (row) => {
      const updateCart = async () => {
        try {
          await axios.delete(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/delete/${row.idkeranjang}`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
          });
          const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
          });

          let jmlQ = 0;
          let totalH = 0;

          setCart(cartData.data.result);
          
          cartData.data.result.forEach((item) => {
            jmlQ += item.jmlh;
            totalH += item.subtotal;
          });

          setCheckedAllItem(false);
          setTobeCheckedOut([]);
          setCheckedIdProduk([]);
          setCheckedQty(0);
          setCheckedTotal(0);

          UpdatedJmlState(jmlQ);
          UpdatedTotalState(totalH);
          
          setCart(cartData.data.result);
          UpdatedCartState(cartData.data.result);
        } catch (err) {
          console.log(err);
        }
      };

      await updateCart();
      await getProducts();
    };
  
    useEffect(() => {
      const getCart = async () => {
        try {
          const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
          });

          let jmlQ = 0;
          let totalH = 0;

          setCart(cartData.data.result);
          
          cartData.data.result.forEach((item) => {
            jmlQ += item.jmlh;
            totalH += item.subtotal;
          });

          UpdatedJmlState(jmlQ);
          UpdatedTotalState(totalH);

        } catch (err) {
          console.log(err);
        }
      };
      const getSaldo = async () => {
        try {
            const saldo = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/saldo`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
            });
            let debitData = 0;
            let creditData = 0;
            saldo.data.result.forEach((v) => {
                debitData += v.debit;
                creditData += v.credit;
            });
            setSaldoData(debitData - creditData);
        } catch (err) {
            console.log(err);
        }
      };

      if(verifyToken(token)){
        getCart();
        getSaldo();
      }
    }, [])

    return (
        <Container>
            <Wrapper>
                <Snackbar
                  open={openAlert}
                  autoHideDuration={2500}
                  onClose={handleCloseAlert}
                  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                  key={'top' + 'center'}
                >
                    <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                        {alertMessage}
                    </Alert>
                </Snackbar>
                <Modal
                    open={openCart}
                    onClose={handleCloseCart}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                  <Box sx={modalStyle}>
                      {cartState && cartState.length > 0 && (
                          <Grid container>
                              <Grid item xs={12}>
                                  <TableContainer component={Paper} sx={{ maxHeight: '50vh' }}>
                                      <Table aria-label="customized table" stickyHeader>
                                          <TableHead>
                                              <TableRow>
                                                  <StyledTableCell align="center">
                                                    <Checkbox
                                                      onChange={(event) => {
                                                        const arr = [];
                                                        const arrId = [];
                                                        setCheckedAllItem(!checkedAllItem);
                                                        if(event.target.checked) {
                                                          cartState.forEach((row) => {
                                                            arr.push(row);
                                                            arrId.push(row.idproduk);
                                                            setCheckedQty(prevState => prevState + row.jmlh);
                                                            setCheckedTotal(prevState => prevState + row.subtotal);
                                                          });
                                                          setTobeCheckedOut(arr);
                                                          setCheckedIdProduk(arrId);
                                                        } else {
                                                          setTobeCheckedOut([]);
                                                          setCheckedIdProduk([]);
                                                          setCheckedQty(0);
                                                          setCheckedTotal(0);
                                                        };
                                                      }}
                                                      checked={checkedAllItem}
                                                    />
                                                  </StyledTableCell>
                                                  <StyledTableCell align="center"></StyledTableCell>
                                                  <StyledTableCell align="center">Nama</StyledTableCell>
                                                  <StyledTableCell align="center">Harga</StyledTableCell>
                                                  <StyledTableCell align="center">Jumlah</StyledTableCell>
                                                  <StyledTableCell align="center">Subtotal</StyledTableCell>
                                              </TableRow>
                                          </TableHead>
                                          <TableBody>
                                              {cartState && (
                                                  cartState.map((row) => (
                                                      <StyledTableRow key={row.idproduk}>
                                                          <StyledTableCell sx={{ maxWidth: '5px' }}>
                                                            <Checkbox
                                                              onChange={(event) => {
                                                                if(event.target.checked) {
                                                                  setTobeCheckedOut(prevState => [...prevState, row]);
                                                                  setCheckedQty(prevState => prevState + row.jmlh);
                                                                  setCheckedTotal(prevState => prevState + row.subtotal);
                                                                  setCheckedIdProduk(prevState => [...prevState, row.idproduk])
                                                                } else {
                                                                  setCheckedAllItem(false);
                                                                  setTobeCheckedOut(tobeCheckedOut.filter((v) => v !== row));
                                                                  setCheckedIdProduk(checkedIdProduk.filter((v) => v !== row.idproduk))
                                                                  setCheckedQty(prevState => prevState - row.jmlh);
                                                                  setCheckedTotal(prevState => prevState - row.subtotal);
                                                                }
                                                              }}
                                                              checked={checkedIdProduk.includes(row.idproduk) || checkedAllItem}
                                                            />
                                                          </StyledTableCell>
                                                          <StyledTableCell sx={{ maxWidth: '5px' }}>
                                                              <DeleteIcon
                                                                  color="primary"
                                                                  fontSize="small"
                                                                  onClick={() =>handleDeleteCart(row)}
                                                              />
                                                          </StyledTableCell>
                                                          <StyledTableCell sx={{ minWidth: '90px' }}>
                                                            {row.namaproduk}
                                                          </StyledTableCell>
                                                          <StyledTableCell sx={{ minWidth: '90px' }} align="right">
                                                              Rp {row.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                              {/* {(new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date) ? (
                                                                <>
                                                                  Rp.&nbsp; 
                                                                  <s>{row.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</s>&nbsp;
                                                                  {(row.jenis === 'gamis' || row.jenis === 'koko') ? (
                                                                    <>
                                                                      {(100000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      {(50000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                                    </>
                                                                  )}
                                                                </>
                                                              ) : (
                                                                <>
                                                                  Rp. {row.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                                </>
                                                              )} */}
                                                          </StyledTableCell>
                                                          <StyledTableCell align="center" sx={{ minWidth: '150px' }}>
                                                              <IconButton aria-label="delete" disabled={row.jmlh <= 1}>
                                                                <RemoveIcon fontSize="small" onClick={() => handleValToSubmit(row, -1)}/>
                                                              </IconButton>
                                                              <TextField
                                                                  sx={{ width: '70px' }}
                                                                  size="small"
                                                                  required
                                                                  disabled
                                                                  type="number"
                                                                  inputProps={{ inputMode: 'numeric', pattern: '[0-9]*',  min: 1 } }
                                                                  id="outlined-basic"
                                                                  variant="outlined"
                                                                  value={row.jmlh}
                                                              />
                                                              <IconButton aria-label="delete">
                                                                <AddIcon fontSize="small" onClick={() => handleValToSubmit(row, 1)}/>
                                                              </IconButton>
                                                          </StyledTableCell>
                                                          <StyledTableCell sx={{ minWidth: '100px' }} align="right">
                                                              Rp {row.subtotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                              {/* {(new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date) ? (
                                                                <>
                                                                  Rp.&nbsp;
                                                                  {(row.jenis === 'gamis' || row.jenis === 'koko') ? (
                                                                    <>
                                                                      {(row.jmlh * 100000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      {(row.jmlh * 50000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                                    </>
                                                                  )}
                                                                </>
                                                              ) : (
                                                                <>
                                                                  Rp. {row.subtotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                                </>
                                                              )} */}
                                                          </StyledTableCell>
                                                      </StyledTableRow>
                                                  ))
                                              )}
                                          </TableBody>
                                      </Table>
                                  </TableContainer>
                              </Grid>
                              <Grid item xs={12}>
                                  <Grid container>
                                      <Grid item xs={8} align="right" sx={{ backgroundColor: '#E5E9EE', paddingRight: 2 }}>
                                          <Typography variant="body2">Jumlah QTY</Typography>
                                      </Grid>
                                      <Grid item xs={4} align="right" sx={{ backgroundColor: '#C6D0D9', paddingRight: 1 }}>
                                          <Typography variant="body2" fontWeight="700">{checkedQty}</Typography>
                                      </Grid>
                                      {/* <Grid item xs={8} align="right" sx={{ backgroundColor: '#E5E9EE', paddingRight: 2 }}>
                                          <Typography variant="body2">Total</Typography>
                                      </Grid> */}
                                      {/* <Grid item xs={4} align="right" sx={{ backgroundColor: '#C6D0D9', paddingRight: 1 }}>
                                        {checkedTotal > 0 && (
                                          <Typography variant="body2" fontWeight="700">
                                            Rp {checkedTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                          </Typography>
                                        )}
                                        {checkedTotal === 0 && (
                                          <Typography variant="body2" fontWeight="700">
                                            Rp 0
                                          </Typography>
                                        )}
                                      </Grid> */}
                                  </Grid>
                              </Grid>
                              <Grid item xs={12} align="center" sx={{ paddingY: 2 }}>
                                  <Button
                                      disabled={tobeCheckedOut.length === 0 || checkedIdProduk.length === 0}
                                      variant="contained"
                                      onClick={async () => {
                                          try {

                                            const values = tobeCheckedOut.map((item) => {
                                              return {
                                                idkeranjang: item.idkeranjang,
                                                idproduk: item.idproduk,
                                                harga: item.harga,
                                                jumlah: item.jmlh,
                                                subtotal: item.subtotal,
                                                berat: parseInt(item.berat)
                                              };  
                                            });

                                            const kirim = await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/checkout`, values, {
                                              headers: {
                                                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                              }
                                            });
                                            localStorage.setItem('invoicePengiriman', kirim.data.result);
                                            const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
                                              headers: {
                                                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                              }
                                            });
                                  
                                            let jmlQ = 0;
                                            let totalH = 0;
                                  
                                            setCart(cartData.data.result);
                                            
                                            cartData.data.result.forEach((item) => {
                                              jmlQ += item.jmlh;
                                              totalH += item.subtotal;
                                            });
                                  
                                            UpdatedJmlState(jmlQ);
                                            UpdatedTotalState(totalH);
                                  
                                            setCart(cartData.data.result);
                                            UpdatedCartState(cartData.data.result);
                                            navigate('/dashboard/readystock/kirim');

                                          } catch (err) {
                                            console.log(err);
                                          }
                                          handleCloseCart();
                                      }}
                                  >
                                      Checkout
                                  </Button>
                              </Grid>
                          </Grid>
                      )}
                      {(!cartState || cartState.length === 0) && (
                          <Grid container>
                              <Grid item xs={12} align="center">
                                  <Typography variant="h6">Keranjang belanja kosong</Typography>
                              </Grid>
                              <Grid item xs={12} align="center" sx={{ paddingY: 2 }}>
                                  <ProductionQuantityLimitsIcon fontSize="large" color="disabled" />
                              </Grid>
                              <Grid item xs={12} align="center" sx={{ paddingY: 2 }}>
                                  <Button
                                      variant="contained"
                                      onClick={() => {
                                          handleCloseCart();
                                      }}
                                  >
                                      Kembali
                                  </Button>
                              </Grid>
                          </Grid>
                      )}
                  </Box>
                </Modal>
                <Grid container spacing={0}>
                  <Grid item xs={8} md={8} sx={{ display: 'flex', margin: 'auto' }}>
                    <Grid container spacing={1}>
                      <Grid item xs={1} sm={2} md={3} display="flex">
                        <Grid container direction="column" display="flex" justifyContent="center">
                          {window.location.pathname.split('/').length > 2 && (
                            <Grid item xs={2}>
                              <ArrowBackIosIcon onClick={() => history.back()} />
                            </Grid>
                          )}
                          <Grid
                            item
                            xs={10}
                            sx={{ display: {xs: 'none', sm: 'block', md: 'block'} }}
                          >
                            <img
                              src={mainLogo}
                              width="50%"
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={2} sx={{ display: { xs: 'flex', md: 'none' }, margin: 'auto' }}>
                    {cartState && cartState.length > 0 && (
                        <CartItem>
                            <Typography sx={{fontSize: '12px'}}>
                                {cartState.length}
                            </Typography>
                        </CartItem>
                    )}
                    <ShoppingCart
                      fontSize="large"
                      onClick={() => setOpenCart(true)}
                    />
                  </Grid>

                  <Grid
                    item
                    md={4}
                    sx={{
                      display: { xs: 'none', md: 'flex', margin: 'auto' }
                    }}
                  >
                    <Grid container spacing={3} justifyContent="flex-end">
                      <Grid item direction="column" flexDirection="column">
                        <Grid container spacing={1}>
                          <Grid item><LocalAtm /></Grid>
                          <Grid item>
                            <Box sx={{
                              backgroundColor: 'white',
                              '&:hover': {
                                cursor: 'pointer'
                              },
                              padding: '1px 7px',
                              borderRadius: '5px'
                            }}>
                              <Link
                                to="/dashboard/saldo"
                                style={{
                                  textDecoration: 'none',
                                  display: 'flex',
                                  alignItems: 'center',
                                  color: 'grey',
                                  '&:hover': {
                                    color: '#000'
                                  }
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  style={{ fontWeight: 700 }}
                                >
                                  {/* Rp. 21.000.000 */}
                                  Rp. {saldoData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                </Typography>
                              </Link>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item>
                        {cartState && cartState.length > 0 && (
                          <CartItem>
                              <Typography sx={{fontSize: '12px'}}>
                                  {cartState.length}
                              </Typography>
                          </CartItem>
                        )}
                        <ShoppingCart
                          style={{
                            cursor: 'pointer'
                          }}
                          onClick={() => setOpenCart(true)}
                        />
                      </Grid>
                      <Grid item>
                        <Email
                          style={{
                            cursor: 'pointer'
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <Notifications
                          style={{
                            cursor: 'pointer'
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <ExitToApp
                          onClick={handleLogout}
                          style={{
                            cursor: 'pointer'
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sm={2}
                    sx={{
                      display: { xs: 'flex', md: 'none' },
                      alignItems: 'center',
                      textAlign: 'center'
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                      <IconButton
                        onClick={handleClickMenu}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                      >
                        <MenuIcon sx={{ fontSize: '44px' }}/>
                      </IconButton>
                    </Box>
                  </Grid>
                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleCloseMenu}
                    onClick={handleCloseMenu}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        width: { xs: '70%', sm: '50%' },
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                        },
                        '&:before': {
                          content: '""',
                          display: 'block',
                          position: 'absolute',
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: 'background.paper',
                          transform: 'translateY(-50%) rotate(45deg)',
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <MenuItem>
                      <Link
                        to="/dashboard/saldo"
                        style={{
                          textDecoration: 'none',
                          display: 'flex',
                          alignItems: 'center',
                          color: '#4d5869',
                          '&:hover': {
                            color: '#000'
                          }
                        }}
                      >
                        <LocalAtm /> &nbsp; Rp. {saldoData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                      </Link>
                    </MenuItem>
                    <MenuItem>
                      <Link
                        to="/dashboard/pesan"
                        style={{
                          textDecoration: 'none',
                          display: 'flex',
                          alignItems: 'center',
                          color: '#4d5869',
                          '&:hover': {
                            color: '#000'
                          }
                        }}
                      >
                        <Email /> &nbsp; Message
                      </Link>
                    </MenuItem>
                    <MenuItem>
                      <Notifications /> &nbsp; Notifications
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={handleLogout}>
                      <ListItemIcon>
                        <ExitToApp fontSize="small" />
                      </ListItemIcon>
                      Logout
                    </MenuItem>
                  </Menu>
                </Grid>  
            </Wrapper>
        </Container>
    )
}

export default Navbar
